import {ColorBackground, ColorTheme} from "../styles/Colors";

export const NavHeaderTitleTintColor = ColorTheme;
export const NavHeaderTintColor = ColorBackground;

export const NavHeaderIconSize = 18;
export const NavHeaderIconWidth = 42;
